/**
 * ZipCodeBody.js
 *
 * Renders the body of the ZIP code selection step.
 */
import React from 'react';
import PropTypes from 'prop-types';
import FormField from '@/forms/_common/FormField';
import StringField from '@/forms/_fields_v2/StringField';
import Loader from '@/components/Loader';
import ZipCodeActiveCard from './ZipCodeActiveCard';
import ZipCodeInactiveCard from './ZipCodeInactiveCard';

ZipCodeBody.propTypes = {
  zipData: PropTypes.object.isRequired,
  debouncedZipCode: PropTypes.string,
  isSearching: PropTypes.bool,
  city: PropTypes.string,
  state: PropTypes.string,
  siteCount: PropTypes.number,
  showErrors: PropTypes.bool,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
};

/**
 * Renders the ZIP code input field and displays search results (active/inactive cards).
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered ZIP code body.
 */
export default function ZipCodeBody(props) {
  const { zipData, debouncedZipCode, isSearching, city, state, siteCount, showErrors, errors, onChange } = props;
  const isValidZipCode = debouncedZipCode?.length >= 5;
  return (
    <div className="flex flex-col lg:flex-row gap-8 items-start mb-12">
      <div className="w-[291px] shrink-0">
        <FormField name="zipCode" data={zipData} errors={showErrors && errors} onChange={onChange}>
          {(field) => (
            <StringField
              label="Enter your ZIP Code"
              required={true}
              value={field.value}
              error={field.error}
              disabled={isSearching && field.value?.length >= 5}
              onChange={field.onChange}
            />
          )}
        </FormField>
      </div>
      {isValidZipCode && isSearching && (
        <div className="flex-1 pt-[28px] flex justify-start">
          <Loader />
        </div>
      )}
      {isValidZipCode && !isSearching && (
        <div className="flex-1 pt-[28px]">
          {siteCount > 0 ? (
            <ZipCodeActiveCard city={city} state={state} />
          ) : (
            <ZipCodeInactiveCard city={city} state={state} />
          )}
        </div>
      )}
    </div>
  );
}
